<template>
  <div :class="['field-artwork', { 'field-artwork--card': isUsedByCard }]">
    <ArticleHeadMenu v-if="isMobile" />

    <span class="field-artwork__field" v-if="temple || space">
      <img src="@/assets/images/header/house_new.svg" alt="" />
      {{ temple }}
      <span v-if="temple && space" tabindex="-1">|</span>
      {{ space }}
    </span>

    <span class="field-artwork__field" v-if="identity && isMobile">
      <img src="@/assets/images/header/house_new.svg" alt="" />
      {{ identity }}
    </span>
  </div>
</template>

<script>
import ArticleHeadMenu from '../article/ArticleHeadMenu';

export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    isUsedByCard: {
      type: Boolean,
      default: false,
    },
    temple: {
      type: String,
      default: '',
    },
    space: {
      type: String,
      default: '',
    },
    identity: {
      type: String,
      default: '',
    },
  },
  components: {
    ArticleHeadMenu,
  },
};
</script>

<style lang="scss" scoped>
.field-artwork {
  padding-bottom: 20px;
  margin: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-bottom: 1px solid $color-light-border;

  @include for-desktop {
    padding-bottom: 0;
    align-items: center;
    border-bottom: 0;
    margin: 0;
  }

  &__field {
    width: 268px;
    color: $color-light-text;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-top: 20px;
    > img {
      margin-right: 10px;
    }
    > span {
      margin: 0 10px;
    }
    & + .field-artwork__field {
      margin-top: 10px;
    }
    @include for-desktop {
      width: 100%;
      justify-content: center;
      margin-top: 0px;
    }
  }

  &--card {
    margin: 0 0 10px;
    padding-bottom: 0;
    border-bottom: 0;

    .field-artwork__field {
      margin-top: 0;
    }
  }
}
</style>
